import { render, staticRenderFns } from "./SelectGroupForm.vue?vue&type=template&id=5909c948"
import script from "./SelectGroupForm.vue?vue&type=script&lang=js"
export * from "./SelectGroupForm.vue?vue&type=script&lang=js"
import style0 from "./SelectGroupForm.vue?vue&type=style&index=0&id=5909c948&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports